/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Review_Pending_FieldsInputs */

const en_case_section_review_pending_fields = /** @type {(inputs: Case_Section_Review_Pending_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required fields pending`)
};

const pt_br2_case_section_review_pending_fields = /** @type {(inputs: Case_Section_Review_Pending_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campos obrigatórios pendentes`)
};

/**
* | output |
* | --- |
* | "Required fields pending" |
*
* @param {Case_Section_Review_Pending_FieldsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_review_pending_fields = /** @type {((inputs?: Case_Section_Review_Pending_FieldsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Review_Pending_FieldsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_review_pending_fields(inputs)
	return pt_br2_case_section_review_pending_fields(inputs)
});